import {format, getDate, getMonth, getYear} from "date-fns";


export default class ContractDetails {

	constructor(details, subscription,value, juridique, userAccount) {
		details = details || {};
		const {bankCoordinates } = details || {};
		const {title={}, firstName, lastName} = userAccount.name || "";
		const {address1, city, zipCode} = userAccount.address || "";
		const fullName = `${lastName}`;
		const currentDate = new Date();
		// const {bic, iban} = bankCoordinates || "";
		const {iban} = bankCoordinates || "";
		const cle1 = iban && iban.substring(0, 4);
		const cle2 = iban && iban.substring(4, 8) || "";
		const cle3 = iban && iban.substring(8, 12) || "";
		const cle4 = iban && iban.substring(12, 16) || "";
		const cle5 = iban && iban.substring(16, 20) || "";
		const cle6 = iban && iban.substring(20);
			//entite juridique
		const {seller = {}} = juridique || {};
		const {address: juriduqueAddr = {}} = seller || {};
		const {description: sellerName = ""} = seller || {};
		const {customFields: juriduqueCustomFields = {}} = seller || {};
		const {customField: juriduqueCustomField = {}} = juriduqueCustomFields || {};
		// const {inheritedCustomField} = juriduqueCustomFields || {};
		// const legalTypeCF = juriduqueCustomField.find(field => field.code === LEGAL_TYPE_CF) || {}
		// const legalType = legalTypeCF.stringValue || "";
		// const icsCF = (inheritedCustomField || []).find(field => field.code === ICS_CF) || "";
		// const ics = icsCF.stringValue || "";
		const ibanAddress1 = juriduqueAddr.address1 ? juriduqueAddr.address1 +"\n" : "";
		const ibanAddress2 = juriduqueAddr.address2 ? juriduqueAddr.address2 +"\n" : "";
		const ibanAddress3 = juriduqueAddr.address3 ? juriduqueAddr.address3 +"\n" : "";
		const ibanCity = juriduqueAddr.city || "";
		const ibanZip = juriduqueAddr.zipCode || "";
		const ibanCountry = COUNTRY[juriduqueAddr.country] || "";
		this.returnPdf = false;
		this.documentDestinationDir = GENERATED_ASSETS_PATH;
		this.documentNamePrefix = subscription.code;
		this.listTemplates = [
			{
				"templatePath": `${AUTHORIZATION_IBAN_TEMPLATE}`,
				"templateName":  `${value}_AutorisationIBAN`,
				"templateFields": {
					"rum": value,
					"nomPrenomClient": fullName,
					"adresseClient": address1	,
					"villeClient": city,
					"codePostalClient": zipCode,
					// "codeBic": bic,
					"codePaysIban": cle1,
					"cle1": cle2,
					"cle2": cle3,
					"cle3": cle4,
					"cle4": cle5,
					"cle5": cle6,
					"nomCreancier": `${sellerName}`,
					"adresseCreancier": ibanAddress1 + ibanAddress2 + ibanAddress3,
					"villeCreancier": ibanCity,
					"paysCreancier": ibanCountry,
					// "idCreancier": ics,
					"codePostalCreancier": ibanZip,
					"lieu": ibanCity,
					"jourSignature": getDate(currentDate),
					"moisSignature": getMonth(currentDate) + 1,
					"anneeSignature": getYear(currentDate),
					"numeroContrat": subscription.code,
					"contactName": firstName + " " + lastName,
					"dateCreationContrat": format(currentDate, "DD/MM/YYYY"),
					"offer": subscription.offer && subscription.offer.name
					
				}
			}
		];
	}
}



// WEBPACK FOOTER //
// ./src/opencell/model/ContractDetails.js